'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

exports.searchReducer = searchReducer;
exports.shareClassReducer = shareClassReducer;
exports.shareClassDetails = shareClassDetails;
exports.searchFunds = searchFunds;
exports.companyReducer = companyReducer;
exports.companies = companies;
exports.companydetailsReducer = companydetailsReducer;
exports.companydetails = companydetails;
exports.tutorialdismissReducer = tutorialdismissReducer;
exports.tutorialdismissChange = tutorialdismissChange;
exports.compareReducer = compareReducer;
exports.compareShareclasses = compareShareclasses;
exports.cartReducer = cartReducer;
exports.cartChange = cartChange;
exports.searchCompaniesReducer = searchCompaniesReducer;
exports.searchCompanies = searchCompanies;

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SEARCH = 'search';
var SEARCH_FAIL = 'search/fail';
var SEARCH_SUCCESS = 'search/success';

var SHARE_CLASS = 'share_class';
var SHARE_CLASS_FAIL = 'share_class/fail';
var SHARE_CLASS_SUCCESS = 'share_class/success';

var initialState = {};

function whereParams(prefix, whereBy) {
  if (!whereBy) {
    return {};
  }
  var params = {};
  whereBy.forEach(function (where) {
    if (where) {
      if (where.op === 'eq') {
        params[prefix + '[' + where.name + ']'] = where.value;
      } else {
        params[prefix + '[' + where.name + '][' + where.op + ']'] = where.value;
      }
    }
  });
  return params;
}
function searchFundParam(params, idx, name, value, whereBy) {
  // params['filter[where][or][' + idx + '][' + name + '][like]'] = '%' + value + '%'
  params['filter[where][or][' + idx + '][' + name + '][regexp]'] = '/.*' + value + '.*/i';
  // params['filter[where][or][' + idx + '][' + name + '][regexp]'] = '.*'
  params['filter[where][or][' + idx + '][version]'] = _config2.default.environment.version;
  // params['filter[where][or][' + idx + '][usd_relative_footprint][gt]'] = 0
  params = (0, _assign2.default)({}, params, whereParams('filter[where][or][' + idx + ']', whereBy));

  // params['filter[where][and][' + idx + '][portfolio_carbon_relative_carbon_footprint][gt]'] = 0

  return params;
}
function baseReducer(state, action, actionTypes) {
  switch (action.type) {
    case actionTypes[0]:
      return (0, _extends3.default)({}, state, {
        loading: true,
        loaded: false,
        result: null,
        error: null
      });
    case actionTypes[1]:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        result: action.result,
        error: null
      });
    case actionTypes[2]:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        result: null,
        error: action.error
      });
    default:
      return state;
  }
}

function searchReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return baseReducer(state, action, [SEARCH, SEARCH_SUCCESS, SEARCH_FAIL]);
}
function shareClassReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return baseReducer(state, action, [SHARE_CLASS, SHARE_CLASS_SUCCESS, SHARE_CLASS_FAIL]);
}

function shareClassDetails(fundId, investmentVehicleId) {
  return {
    types: [SHARE_CLASS, SHARE_CLASS_SUCCESS, SHARE_CLASS_FAIL],
    promise: function promise(client) {
      return _bluebird2.default.all([client.get('/shareclasses', {
        params: {
          'filter[where][investment_vehicle_id]': investmentVehicleId,
          'filter[where][version]': _config2.default.environment.version
        }
      }), client.get('/funds', {
        params: {
          'filter[include]': ['fundholdings', 'holdings'],
          'filter[where][fund_id]': fundId,
          'filter[where][version]': _config2.default.environment.version
        }
      })]).then(function (results) {
        var shareClassResult = results[0] && results[0][0] ? results[0][0] : null;
        var fundResult = results[1] && results[1][0] ? results[1][0] : null;
        return {
          shareClass: shareClassResult,
          fund: fundResult
        };
      });
    }
  };
}

function searchFunds(req, page, orderBy, whereBy, isDesc, noLimit) {
  var defaultSort = [
  // {order:'c2f5coogutweight', isDesc:false},
  { order: 'ussif', isDesc: true },
  // {order:'badge_count', isDesc:true},
  { order: 'fund_share_class_net_assets', isDesc: true }];

  console.log('searchFunds:', { req: req, page: page, where: whereBy ? (0, _stringify2.default)(whereBy) : '', order: orderBy, desc: isDesc, noLimit: noLimit });
  page = page || 1;

  var params = {
    'filter[limit]': noLimit ? page * _config2.default.queryMaxFunds : _config2.default.queryMaxFunds,
    'filter[skip]': noLimit ? 0 : (page - 1) * _config2.default.queryMaxFunds
  };

  if (orderBy) {
    params = (0, _assign2.default)(params, {
      'filter[order][0]': orderBy + ' ' + (isDesc ? 'DESC' : 'ASC')
    });
    var idx = 1;
    // loop through default sorts
    defaultSort.forEach(function (sort) {
      if (sort.order !== orderBy) {
        // if its not orderBy add it
        params['filter[order][' + idx++ + ']'] = sort.order + ' ' + (sort.isDesc ? 'DESC' : 'ASC');
      }
    });
  } else {
    params = (0, _assign2.default)(params, {
      // 'filter[order][0]':'badge_count DESC',
      'filter[order][0]': 'ussif DESC',
      'filter[order][1]': 'fund_share_class_net_assets DESC'
    });
  }

  if (req) {
    // const lowerReq = req.toLowerCase()
    // const upperReq = req.toUpperCase()
    var _idx = 0;
    params = searchFundParam(params, _idx++, 'name', req, whereBy);
    // params = searchFundParam(params, idx++, 'name', lowerReq, whereBy )
    params = searchFundParam(params, _idx++, 'fund_legal_name', req, whereBy);
    // params = searchFundParam(params, idx++, 'fund_legal_name', lowerReq, whereBy )
    params = searchFundParam(params, _idx++, 'fund_family_name', req, whereBy);
    // params = searchFundParam(params, idx++, 'fund_family_name', lowerReq, whereBy )
    params = searchFundParam(params, _idx++, 'ticker', req, whereBy);
    console.log(params);
  } else {
    params = (0, _assign2.default)({}, params, whereParams('filter[where]', whereBy));
    params = (0, _assign2.default)({}, params, {
      'filter[where][version]': _config2.default.environment.version
    });
  }

  // console.log('searchFunds params:',params )
  return {
    types: [SEARCH, SEARCH_SUCCESS, SEARCH_FAIL],
    promise: function promise(client) {
      return client.get('/shareclasses', {
        params: params
      }).then(function (result) {
        return { results: result, req: req, orderBy: orderBy };
      });
    }
  };
}

var COMPANY = 'company';
var COMPANY_SUCCESS = 'company/success';
var COMPANY_FAIL = 'company/fail';

function companyReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return baseReducer(state, action, [COMPANY, COMPANY_SUCCESS, COMPANY_FAIL]);
}

function companies() {
  var isScreen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  if (!isScreen) {
    return {};
  }

  var params = {
    'filter[fields][short_name]': 'true',
    'filter[fields][primary_symbol]': 'true',
    'filter[fields][legal_name]': 'true',
    'filter[fields][version]': 'true',
    'filter[limit]': 10000,
    'filter[where][and][0][version]': _config2.default.environment.version
  };

  // 'filter[fields][is_gm]':'true',
  // 'filter[where][and][is_gm]':1,
  params['filter[fields][' + isScreen + ']'] = 'true';
  params['filter[where][and][0][' + isScreen + ']'] = 1;

  return {
    types: [COMPANY, COMPANY_SUCCESS, COMPANY_FAIL],
    promise: function promise(client) {
      return client.get('/companies', {
        params: params
      }).then(function (result) {
        return { result: result };
      });
    }
  };
}

var COMPANYDETAILS = 'companydetails';
var COMPANYDETAILS_SUCCESS = 'companydetails/success';
var COMPANYDETAILS_FAIL = 'companydetails/fail';

function companydetailsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return baseReducer(state, action, [COMPANYDETAILS, COMPANYDETAILS_SUCCESS, COMPANYDETAILS_FAIL]);
}

function companydetails() {
  var companyId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  if (!companyId) {
    return {};
  }

  var params = {
    'filter[where][and][0][version]': _config2.default.environment.version
  };
  params['filter[where][and][0][company_id]'] = companyId;

  return {
    types: [COMPANYDETAILS, COMPANYDETAILS_SUCCESS, COMPANYDETAILS_FAIL],
    promise: function promise(client) {
      return client.get('/companies', {
        params: params
      }).then(function (result) {
        return { result: result };
      });
    }
  };
}

var TUTORIALDISMISS = 'tutorialdismiss';
var TUTORIALDISMISS_FAIL = 'tutorialdismiss/fail';
var TUTORIALDISMISS_SUCCESS = 'tutorialdismiss/success';

function tutorialdismissReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return baseReducer(state, action, [TUTORIALDISMISS, TUTORIALDISMISS_FAIL, TUTORIALDISMISS_SUCCESS]);
}

function tutorialdismissChange() {
  var tutorialdismiss = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  return {
    types: [TUTORIALDISMISS, TUTORIALDISMISS_FAIL, TUTORIALDISMISS_SUCCESS],
    promise: function promise(client) {
      return _bluebird2.default.all([new _bluebird2.default(function (resolve, reject) {
        resolve(tutorialdismiss);
      })]).then(function (results) {
        return results.length ? results[0] : false;
      });
    }
  };
}

var COMPARE = 'compare';
var COMPARE_FAIL = 'compare/fail';
var COMPARE_SUCCESS = 'compare/success';

function compareReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return baseReducer(state, action, [COMPARE, COMPARE_SUCCESS, COMPARE_FAIL]);
}

// up to 4 shareclass ids will be provided
function compareShareclasses() {
  var s1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var s2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var s3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var s4 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var prefix = 'filter[where][or][';
  var shareclassIds = [s1, s2, s3, s4];
  var count = 0;
  var shareclassParams = {
    'filter[limit]': 4,
    'filter[include]': ['fund'],
    'filter[include][fund]': ['shareclass']
  };
  shareclassIds.forEach(function (id) {
    if (typeof id !== 'undefined' && id !== null && id !== 'N') {
      shareclassParams[prefix + count + '][investment_vehicle_id]'] = id;
      shareclassParams[prefix + count + '][version]'] = _config2.default.environment.version;
      count += 1;
    }
  });
  return {
    types: [COMPARE, COMPARE_SUCCESS, COMPARE_FAIL],
    promise: function promise(client) {
      return client.get('/shareclasses', {
        params: shareclassParams
      }).then(function (result) {
        return { results: result };
      });
    }
  };
}

var CART = 'cart';
var CART_FAIL = 'cart/fail';
var CART_SUCCESS = 'cart/success';

function cartReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return baseReducer(state, action, [CART, CART_SUCCESS, CART_FAIL]);
}

function cartChange() {
  var cart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var newShareclass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    types: [CART, CART_SUCCESS, CART_FAIL],
    promise: function promise(client) {
      return _bluebird2.default.all([new _bluebird2.default(function (resolve, reject) {
        var CART_MAX = 4;
        var EMPTY_SLOT_ID = 'N';
        var generateEmptySlot = function generateEmptySlot() {
          return { id: EMPTY_SLOT_ID, shareclassStub: {} };
        };
        var defaultCart = [];
        for (var i = 0; i < CART_MAX; i++) {
          defaultCart.push(generateEmptySlot());
        }
        if (cart.length !== CART_MAX) {
          cart = defaultCart;
        }
        var newId = newShareclass.investment_vehicle_id || EMPTY_SLOT_ID;
        // if we actually have a new shareclass to add
        if (newId !== EMPTY_SLOT_ID) {
          var cartIndexOfNewId = -1;
          var cartContainsNewId = false;
          var cartIndexOfOpenSlot = -1;
          var cartContainsOpenSlot = false;
          for (var _i = 0; _i < CART_MAX; _i++) {
            if (cart[_i].id === newId) {
              cartIndexOfNewId = _i;
              cartContainsNewId = true;
            } else if (cart[_i].id === EMPTY_SLOT_ID && cartIndexOfOpenSlot === -1) {
              cartIndexOfOpenSlot = _i;
              cartContainsOpenSlot = true;
            }
          }
          if (cartContainsNewId) {
            // if the cart has the id, it's a remove job.
            // assign 'N' to overwrite the shareclass id.
            cart[cartIndexOfNewId] = generateEmptySlot();
          } else {
            // if the cart does not have the id:
            if (cartContainsOpenSlot) {
              // if there's an open slot, we'll add the id and overwrite the N.
              cart[cartIndexOfOpenSlot] = {
                id: newId,
                shareclassStub: {
                  name: newShareclass.name,
                  ticker: newShareclass.ticker,
                  fund_id: newShareclass.fund_id,
                  investment_vehicle_id: newShareclass.investment_vehicle_id,
                  fund_legal_name: newShareclass.fund_legal_name,
                  fund_family_name: newShareclass.fund_family_name
                }
              };
            }
            // if there's no open slots, we'll do nothing.
          }
        }

        resolve(cart);
      })]).then(function (results) {
        var resultsArr = results[0] ? results[0] : null;
        return { results: resultsArr };
      });
    }
  };
}

// const SEARCHCOMPANIES = 'searchcompanies'
// const SEARCHCOMPANIES_FAIL = 'searchcompanies/fail'
// const SEARCHCOMPANIES_SUCCESS = 'searchcompanies/success'
// SEARCHCOMPANIES, SEARCHCOMPANIES_SUCCESS, SEARCHCOMPANIES_FAIL

function searchCompaniesParam(params, idx, name, value) {
  params['filter[where][or][' + idx + '][' + name + '][regexp]'] = '/.*' + value + '.*/i';
  params['filter[where][or][' + idx + '][version]'] = _config2.default.environment.version;
  params['filter[where][or][' + idx + '][is_dirty]'] = true;
  return params;
}

function searchCompaniesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return baseReducer(state, action, [SEARCH, SEARCH_SUCCESS, SEARCH_FAIL]);
}

function searchCompanies(req) {
  console.log('searchCompanies:', { req: req });

  var params = {
    'filter[limit]': _config2.default.queryMaxFunds,
    'filter[order]': 'short_name ASC'
  };

  if (req) {
    var idx = 0;
    params = searchCompaniesParam(params, idx++, 'short_name', req);
    params = searchCompaniesParam(params, idx++, 'legal_name', req);
    params = searchCompaniesParam(params, idx++, 'primary_symbol', req);
    console.log(params);
  } else {
    params = (0, _assign2.default)({}, params, {
      'filter[where][0][version]': _config2.default.environment.version,
      'filter[where][0][is_dirty]': true
    });
  }
  //
  return {
    types: [SEARCH, SEARCH_SUCCESS, SEARCH_FAIL],
    promise: function promise(client) {
      return client.get('/companies', {
        params: params
      }).then(function (result) {
        return { results: result, req: req };
      });
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/search.js
// module id = 111
// module chunks = 0